export const useUserDescription = (user) => {
  const processedDescription = computed(() => {
    if (!user.value?.description) return []

    if (Number(user.value.id) !== 85849) {
      return [{ text: user.value.description, isLink: false }]
    }

    const text = user.value.description
    const targetWord = 'Crazymamas'
    const index = text.indexOf(targetWord)

    if (index === -1) {
      return [{ text, isLink: false }]
    }

    const parts = []

    // Добавляем текст до первого вхождения
    if (index > 0) {
      parts.push({ text: text.substring(0, index), isLink: false })
    }

    // Добавляем ссылку
    parts.push({ text: targetWord, isLink: true })

    // Добавляем оставшийся текст
    const remainingText = text.substring(index + targetWord.length)
    if (remainingText) {
      parts.push({ text: remainingText, isLink: false })
    }

    return parts
  })

  return {
    processedDescription,
  }
}
